@if (showBackButton) {
  <div class="inner-navigation">
    <div class="back" (click)="navigateBack()">
      <p class="text-button-small">{{ 'claims-details.back-button-text' | translate }}</p>
    </div>
  </div>
}
<div class="claim-title">
  <div class="status" [ngClass]="checkClaimStatus(claim)">
    <p class="tag-12">{{ formatClaimStatus(claim) | translate }}</p>
  </div>
  <div class="title">
    <h4>{{ 'claims-details.claim-number-text' | translate: { claimNumber: claim.identifier } }}</h4>
  </div>
  @if (claim.fnolRequestId && claim.invoiceDocument?.s3Id) {
    <button class="button icon-only pdf-action"
      (click)="openInvoiceDocument()">
      <mat-icon svgIcon="download-light"></mat-icon>
    </button>
  }
</div>
<div class="details-part info">
  <div class="row">
    <div class="title">
      <p class="body-12">{{ 'claims-details.pet-name-text' | translate }}</p>
    </div>
    <div class="value">
      <p class="subtitle-14">{{ petData.pet_name }}</p>
    </div>
  </div>
  <div class="row">
    <div class="title">
      <p class="body-12">{{ 'claims-details.vet-visit-dates-title' | translate }}</p>
    </div>
    <div class="value">
      <p class="subtitle-14">{{ claim.claim_date | date:'dd.MM.yyyy' }}</p>
    </div>
  </div>
  <div class="row">
    <div class="title">
      <p class="body-12">{{ 'claims-details.claim-number-title' | translate }}</p>
    </div>
    <div class="value">
      <p class="subtitle-14">{{ claim.identifier }}</p>
    </div>
  </div>

  <div class="row">
    <div class="title">
      <p class="body-12">{{ 'claims-details.claim-category-title' | translate }}</p>
    </div>
    <div class="value">
      <p class="subtitle-14">{{ claim.type }}</p>
    </div>
  </div>
  <div class="row">
    <div class="title">
      <p class="body-12">{{ 'claims-details.claim-cause-title' | translate }}</p>
    </div>
    <div class="value">
      <p class="subtitle-14">{{ claim.cause }}</p>
    </div>
  </div>
</div>
<div class="details-part calculation">
  <div class="block">
    <div class="row">
      <div class="title">
        <p>{{ 'claims-details.bill-amount-title' | translate }}</p>
      </div>

      <div class="currency">
        <p>CHF</p>
      </div>

      <div class="value">
        <p>{{ claim.benefit_amount | number:'1.2-2' }}</p>
      </div>
    </div>

    <div class="row bottom-border">
      <div class="title">
        <p>{{ 'claims-details.deduction-not-covered' | translate }}</p>
      </div>

      <div class="currency">
        <p>CHF</p>
      </div>

      <div class="value">
        <p>-{{ claim.deduction_non_covered_positions | number:'1.2-2' }}</p>
      </div>
    </div>

    <div class="row bold">
      <div class="title">
        <p>{{ 'claims-details.covered-amount-title' | translate }}</p>
      </div>

      <div class="currency">
        <p>CHF</p>
      </div>

      <div class="value">
        <p>{{ ((claim.benefit_amount || 0) - (claim.deduction_non_covered_positions || 0)) | number:'1.2-2' }}</p>
      </div>
    </div>

    <div class="row empty-row">
      <div></div>
    </div>

    @if (claim.deduction_discount) {
      <div class="row">
        <div class="title">
          <p>{{ 'claims-details.deduction-discount-title' | translate }}</p>
        </div>
        <div class="currency">
          <p>CHF</p>
        </div>
        <div class="value">
          <p>-{{ claim.deduction_discount | number:'1.2-2' }}</p>
        </div>
      </div>
    }

    @if (claim.deduction_yearly_franchise) {
      <div class="row">
        <div class="title">
          <p>{{ 'claims-details.franchise-yearly-title' | translate }}</p>
        </div>
        <div class="currency">
          <p>CHF</p>
        </div>
        <div class="value">
          <p>-{{ claim.deduction_yearly_franchise | number:'1.2-2' }}</p>
        </div>
      </div>
    }

    @if (claim.deduction_deductible) {
      <div class="row">
        <div class="title">
          <p>{{ 'claims-details.deductible-not-covered-title' | translate }}</p>
        </div>
        <div class="currency">
          <p>CHF</p>
        </div>
        <div class="value">
          <p>-{{ claim.deduction_deductible | number:'1.2-2' }}</p>
        </div>
      </div>
    }

    @if (claim.deduction_percentage_deductible) {
      <div class="row">
        <div class="title">
          <p>{{ 'claims-details.deductible-deductible-title' | translate }}</p>
        </div>
        <div class="currency">
          <p>CHF</p>
        </div>
        <div class="value">
          <p>-{{ claim.deduction_percentage_deductible | number:'1.2-2' }}</p>
        </div>
      </div>
    }

    @if (claim.deduction_others) {
      <div class="row">
        <div class="title">
          <p>{{ 'claims-details.deductible-others-title' | translate }}</p>
        </div>
        <div class="currency">
          <p>CHF</p>
        </div>
        <div class="value">
          <p>-{{ claim.deduction_others | number:'1.2-2' }}</p>
        </div>
      </div>
    }

    <div class="row empty-row top-border">
      <div></div>
    </div>

    <div class="row bold">
      <div class="title">
        <p>{{ 'claims-details.paid-amount-title' | translate }}</p>
      </div>

      <div class="currency">
        <p>CHF</p>
      </div>

      <div class="value">
        <p>{{ claim.paid_amount | number:'1.2-2' }}</p>
      </div>
    </div>
  </div>
</div>
